export const titular = [
    {
        "nombre" : "",
        "imagen" : "/assets/imgs/Esc_Hgo.png",
        "funcion" : "Coordinar, ejecutar, evaluar, proponer y dar seguimiento a la política de desarrollo social y humano, para el combate efectivo a la pobreza y la marginación urbana y rural, diseñando estrategias que promuevan la participación ciudadana y la corresponsabilidad social."
    }
]